import { func, types } from 'utils';

export const add = (
	item: types.ItemCart,
	items: types.ItemCart[],
	increment = ''
) => {
	let itam = { ...item };
	let itams = [...items];

	// check if item exists in cart
	const inCart = (itams.find((c) => c.cartItemId === itam.cartItemId) ||
		{}) as types.ItemCart;
	if (inCart && inCart.id) {
		let newQty = 0;
		if (increment === '+') {
			newQty = increment ? (itam.quantity || 1) + 1 : 1;
			itam['quantity'] = newQty;
		}
		if (increment === '-') {
			newQty = increment ? (itam.quantity || 1) - 1 : 1;
			itam['quantity'] = newQty;
		}
		itam['priceTotal'] = total([itam], true, false, true);
		const itemIndex = itams.findIndex(
			(item) => item.cartItemId === itam.cartItemId
		);
		itams[itemIndex] = itam;
		return itams;
	} else {
		itam['quantity'] = itam.quantity || 1;
		itam['priceTotal'] = total([itam], true, false, true);
		itams = itams.concat(itam);
		return itams;
	}
};

export const remove = (item: types.ItemCart, items: types.ItemCart[]) => {
	// check if item exists in cart
	let inCart =
		items.find((c) => c.cartItemId === item.cartItemId) ||
		({} as types.ItemCart);
	if (inCart.id) {
		items = items.filter((itm) => itm.cartItemId !== item.cartItemId);
	}
	return items;
};

export const total = (
	_: types.ItemCart[],
	addQty = true,
	subDiscount = false,
	internal = false
) => {
	const items = internal
		? _
		: ((func.getStorageJson('cart')?.items || []) as types.ItemCart[]);
	let total = 0;
	let discount = 0;
	for (let item of items) {
		let price = +(item.priceDiscount || item.price);
		for (let v = 0; v < Object.keys(item.variants).length; v++) {
			let po = Object.keys(item.variants)[v] as any;
			for (let j = 0; j < (item.variants[po] || []).length; j++) {
				const iop = item.variants[po][j];
				if (iop.price > 0) {
					price = price + +iop.price * +iop.quantity;
				}
			}
		}
		if (addQty) {
			price = price * (item.quantity || 1);
		}
		total += price;
		discount = (discount || 0) + (item.discount || 0);
	}
	return total - (subDiscount ? discount : 0);
};

export const deliveryFee = (channel: string): number => {
	const location = func.getStorageJson('location') || {};
	const activeStore: types.Store = func.getStorageJson('activeStore') || {};
	const deliveryPartners = func.getStorageJson('deliveryPartners') || [];

	const distance = +func.distanceMatrix(
		{ lat: location?.address?.lat, lng: location?.address?.lng },
		{ lat: activeStore?.address.x, lng: activeStore?.address.y },
		true
	);

	if (channel) {
		switch (channel) {
			case 'cr':
				return activeStore?.delivery?.feeType === 'flat'
					? activeStore?.delivery?.fee
					: activeStore?.delivery?.fee * distance;

			default:
				const deliveryPartner = deliveryPartners[channel] || {};
				const deliveryFee = (
					Object.keys(deliveryPartner[location.address.state.toLowerCase()]) ||
					[]
				).find(
					(dist: string) =>
						+dist.split('-')[0] <= distance && distance <= +dist.split('-')[1]
				);
				return deliveryFee
					? deliveryPartner[location.address.state.toLowerCase()][deliveryFee]
					: 0;
		}
	}
	return 0;
};

export const totalItems = (items: any) =>
	items.reduce((a: number, b: any) => a + b.quantity, 0) || 1;

export const myPromos = (params: {
	item?: types.Item | types.ItemCart;
	promotions: types.Promotion[];
	apply?: boolean;
	user?: types.User;
}) => {
	const { item, promotions, user } = params;
	const activeStore: types.Store = func.getStorageJson('activeStore') || {};
	return promotions.filter((promo) => {
		const isWithinStore = promo.stores.includes(activeStore.code);
		const isValid = promo.isActive && promo.isRunning;
		const withinLimit =
			+(promo.limit.maximum || 0) > +(promo.limit.usageCount || 0);
		const isItemPromo = promo.type.includes('ITEM')
			? item && promo.items.length > 0 && promo.items.includes(item.code)
			: true;
		const isFirstTime = promo.preferences?.firstTime
			? user?.preferences?.isFirstTime
			: true;

		return (
			isWithinStore && isValid && withinLimit && isItemPromo && isFirstTime
		);
	});
};

export const promoDiscount = (promo: types.Promotion, priceTotal: number) => {
	if (!promo) return 0;
	const cart = func.getStorageJson('cart') as types.Cart;
	let discount = 0;
	const cartTotal = total(cart.items);
	if (priceTotal) {
		if (promo.type === types.PromotionTypes.FLAT_OFF_ITEM) {
			discount = +promo.value;
		}
		if (promo.type === types.PromotionTypes.PERCENTAGE_OFF_ITEM) {
			discount = priceTotal * (+promo.value / 100);
		}
	} else {
		if (promo.type === types.PromotionTypes.FLAT_OFF_ALL) {
			discount = +promo.value;
		}
		if (promo.type === types.PromotionTypes.PERCENTAGE_OFF_ALL) {
			discount = cartTotal * (+promo.value / 100);
		}
	}

	discount =
		+promo.limit.ceiling && +promo.limit.ceiling < discount
			? +promo.limit.ceiling
			: discount;

	return discount;
};
